import { autoinject } from 'aurelia-framework';

import { GenericApi } from '~/api/generic-api';
import { FetchUtils } from '~/utils/fetch-utils';

export interface QasSearchResult {
	moniker: string;
	picklist: string;
	picklistWithPostcode: string;
	postcode: string;
}

export interface AcurityAddress {
	countryCode: string;
	dpid: string;
	line1: string;
	line2: string;
	locality: string;
	postcode: string;
	state: string;
}

@autoinject
export class QasApi extends GenericApi {
	private static readonly Endpoint = 'api/qas';

	public getAddressFromSearchResult = (
		moniker: string,
	): Promise<AcurityAddress> | undefined => {
		if (!moniker) {
			return undefined;
		}
		const url = this.generateURL(
			GenericApi.apiServerURL + QasApi.Endpoint + '/address-from-search',
			{
				moniker,
			},
		);
		return FetchUtils.getJSONWithParamsInURL<AcurityAddress>(url);
	};
}
